import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails";

export default class extends Controller {
    static values = {
        tableConfig: {
            type: Object,
            default: {
                '#datatable': {
                    autoWidth: false,
                    pageLength: 10,
                    processing: true,
                    language: {
                        url: `/locales/datatables/${document.documentElement.lang || 'en'}.json`,
                        emptyTable: "No assigned tasks"
                    }
                }
            }
        }
    }

    connect() {
        // Simply initialize the table on connect
        this.initializeDataTable()
    }

    disconnect() {
        // Clean up on disconnect
        this.destroyDataTable()
    }

    destroyDataTable() {
        try {
            const table = this.element.querySelector('table#datatable')
            if (table && $.fn.DataTable.isDataTable(table)) {
                $(table).DataTable().destroy()
            }
        } catch (err) {
            console.warn('Error cleaning up DataTable:', err)
        }
    }

    initializeDataTable() {
        try {
            // Clean up any existing instance first
            this.destroyDataTable()
            
            // Get the table
            const table = this.element.querySelector('table#datatable')
            if (!table) return

            // Create configuration
            const config = {
                ...this.tableConfigValue['#datatable'],
                destroy: true,
                responsive: true,
                "createdRow": (row, data, dataIndex) => {
                    $(row).css('cursor', 'pointer');

                    // Add click handler to all cells except the last columns
                    $(row).find('td:not(:last-child)').on('click', function() {
                        const url = $(row).data('url');
                        if (url) {
                            // Standard visit with replace to avoid caching issues
                            window.location.href = url;
                        }
                    });

                    // Add hover effect to the entire row
                    $(row).hover(
                        function () {
                            $(this).css({
                                'background-color': '#f5f5f5'
                            });
                        },
                        function () {
                            $(this).css('background-color', '');
                        }
                    );
                }
            }
            
            // Initialize DataTable
            $(table).DataTable(config)
        } catch (error) {
            console.error('Error initializing DataTable:', error)
        }
    }
}